import { useTranslation } from 'react-i18next'
import { useGetTreatmentInfo } from './useGetTreatmentInfo'

export const useGetTreatmentName = () => {
  const treatmentInfo = useGetTreatmentInfo()
  const { t } = useTranslation()

  return t(treatmentInfo.treatment?.titleKey || '')
}
